// @flow
import { handleActions, type ActionType } from 'redux-actions';
import AsyncValue, { type AsyncValueType } from 'lib/async-value';
import {
  fetchClientUserProfiles,
  storeClientUserProfiles,
  fetchClientExpertUserProfiles,
  storeClientExportUserProfiles,
} from './userProfileActions';
import type { ClientUserProfileRecord } from './types';

type ClientUserProfileRecords = Array<ClientUserProfileRecord>;
type ClientUserProfileState = AsyncValueType<ClientUserProfileRecords>;

export const userProfilesReducer = createReducer({
  fetchAction: fetchClientUserProfiles,
  storeAction: storeClientUserProfiles,
});

export const expertUserProfilesReducer = createReducer({
  fetchAction: fetchClientExpertUserProfiles,
  storeAction: storeClientExportUserProfiles,
});

function createReducer({ fetchAction, storeAction }) {
  return handleActions(
    {
      [fetchAction.toString()]: (
        state: ClientUserProfileState,
        action: ActionType<typeof fetchClientUserProfiles>
      ) => AsyncValue.Pending,

      [storeAction.toString()]: (
        state: ClientUserProfileState,
        action: ActionType<typeof storeClientUserProfiles>
      ) => {
        return action.payload;
      },
    },
    null
  );
}

export function userProfilesSelector(state: ClientUserProfileState) {
  return state;
}



// WEBPACK FOOTER //
// ./src/containers/client/userProfilesReducer.js